import cn from 'classnames';
import {ReactElement, useMemo} from 'react';

interface ILocationDetail {
  telephoneNumber?: string;
  customClassName?: string;
  icon?: ReactElement;
  landLine?: string;
}

const Telephone = ({
  telephoneNumber,
  customClassName,
  icon,
  landLine,
}: ILocationDetail) => {
  const formatLandLine = useMemo(() => {
    if (landLine?.startsWith('0')) {
      const nativeLineCodeNumber = landLine.slice(0, 3);
      const mainLine = landLine.slice(3, landLine.length);
      return `${nativeLineCodeNumber}-${mainLine}`;
    }
  }, [landLine]);
  const formattedLandLine = formatLandLine;
  return (
    <div
      className={cn('flex gap-1 items-center text-gray-800', customClassName)}
    >
      {icon ? icon : <i className="icon-namecall" />}
      {telephoneNumber && (
        <a
          href={`tel:${telephoneNumber}`}
          className="text-sm !text-gray-800 underline underline-offset-2"
        >
          {telephoneNumber}
        </a>
      )}

      {landLine && (
        <a
          href={`tel:${landLine}`}
          className={`text-sm !text-gray-800 underline underline-offset-2 ${
            telephoneNumber && landLine && 'border-r-[1px] border-gray-700 pr-1'
          }`}
        >
          {formattedLandLine}
        </a>
      )}
    </div>
  );
};

export default Telephone;
